import { safeLocalStorage } from "./safeLocalStorage.ts";

export const MOBILE_CORE_LOOP_V4_FLAG = "mobileCoreLoopV4";

const enabledValues = new Set(["1", "enabled", "on", "true"]);
const disabledValues = new Set(["0", "disabled", "false", "off"]);

export const resolveMobileCoreLoopV4FlagValue = (
	value: string | null | undefined,
) => {
	if (value === null || value === undefined || value.trim() === "") {
		return true;
	}

	const normalizedValue = value.trim().toLowerCase();
	if (enabledValues.has(normalizedValue)) {
		return true;
	}

	if (disabledValues.has(normalizedValue)) {
		return false;
	}

	return true;
};

export const isMobileCoreLoopV4Enabled = () => {
	if (typeof window === "undefined") {
		return true;
	}

	return resolveMobileCoreLoopV4FlagValue(
		safeLocalStorage.getItem(MOBILE_CORE_LOOP_V4_FLAG),
	);
};
